import { render, staticRenderFns } from "./KPR.vue?vue&type=template&id=6a59bc28&scoped=true"
import script from "./KPR.vue?vue&type=script&lang=js"
export * from "./KPR.vue?vue&type=script&lang=js"
import style0 from "./KPR.vue?vue&type=style&index=0&id=6a59bc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59bc28",
  null
  
)

export default component.exports